import { SecurityType } from '@interfaces/models';

export const fixedIncomeSecurityTypes: SecurityType[] = [
  // Corporate Bond Types
  SecurityType.CORPORATE_BOND,
  SecurityType.CONVERTIBLE_BOND,
  SecurityType.CORPORATE_BOND_NOTE,
  SecurityType.CORPORATE_BOND_NOTE_CONVERTIBLE,
  SecurityType.CORPORATE_BOND_NON_CONVERTIBLE_DOMESTIC,
  SecurityType.CORPORATE_BOND_NOTE_CONVERTIBLE_DOMESTIC,
  SecurityType.CORPORATE_NOTE_NON_CONVERTIBLE_DOMESTIC,
  SecurityType.CORPORATE_UNITS_BONDS,

  // Treasury Securities
  SecurityType.US_TREASURY_BILL,
  SecurityType.US_TREASURY_NOTE,
  SecurityType.US_TREASURY_BOND,
  SecurityType.US_TREASURY_ZERO_COUPON,
  SecurityType.TREASURY_BILL,
  SecurityType.TREASURY_BOND,
  SecurityType.TREASURY_INFLATION_INDEXED,
  SecurityType.TREASURY_NOTE,
  SecurityType.TREASURY_STRIPS,
  SecurityType.US_TREASURY_FUTURE_BILL,
  SecurityType.US_TREASURY_REGULAR_BOND_NOTE,

  // Government Securities
  SecurityType.OTHER_GOVERNMENT,
  SecurityType.GOVERNMENT_BOND,
  SecurityType.GOVERNMENT_MORTGAGE,
  SecurityType.FEDERAL_AGENCY_BOND,
  SecurityType.FEDERAL_AGENCY_PASS_THROUGH,
  SecurityType.FEDERAL_AGENCY_REGULAR_BILL,

  // Municipal Bonds
  SecurityType.MUNICIPAL_BOND,
  SecurityType.MUNI_ASSESSMENT_DIST,
  SecurityType.MUNI_DOUBLE_BARRELED_BOND,
  SecurityType.MUNI_GENERAL_OBLIGATION,
  SecurityType.MUNI_REVENUE_BOND,
  SecurityType.MUNICIPAL_BOND_NOTE,
  SecurityType.MUNICIPAL_LEASES,
  SecurityType.MUNICIPAL_BOND_SERIAL,
  SecurityType.MUNICIPAL_NOTE_SHORT_TERM,

  // Mortgage Securities
  SecurityType.COLLATERALIZED_MORTGAGE_OBLIGATION,

  // Certificates of Deposit
  SecurityType.CERTIFICATES_OF_DEPOSIT,
  SecurityType.CERTIFICATE_OF_DEPOSIT,

  // Commercial Paper and Short-term
  SecurityType.COMMERCIAL_PAPER,
  SecurityType.COMMERCIAL_PAPER_REGULAR_FLAT_DISCOUNT,
  SecurityType.COMMERCIAL_PAPER_REGULAR_INTEREST_BEARIN,
  SecurityType.SHORT_TERM_PAPER,
  SecurityType.SHORT_TERM_RESERVES,

  // Other Fixed Income
  SecurityType.BOND_UNIT,
  SecurityType.FIXED_INCOME_UNITS,
  SecurityType.BOND,
  SecurityType.MISCELLANEOUS_FIXED_INCOME,
] as const;

export const isFixedIncome = (securityType: SecurityType): boolean => {
  return fixedIncomeSecurityTypes.includes(securityType);
};
